export const endpoints = {
    "clients": {
        cacheKey: "clients",
        getUrl: "client",
        getMultipleUrl: "clients",
        create: "clients/create",
        delete: "client/delete",
    },
    "contracts": {
        cacheKey: "contracts",
        getUrl: "contract",
        getMultipleUrl: "contracts",
        create: "contracts/create",
        delete: "contract/delete",
    },
    "employees": {
        cacheKey: "employees",
        getUrl: "employee",
        getMultipleUrl: "employees",
        create: "employees/create",
        delete: "employee/delete",
    },
    "quotes": {
        cacheKey: "quotes",
        getUrl: "quote",
        getMultipleUrl: "quotes",
        create: "quotes/create",
        delete: "quote/delete",
    },
    "services": {
        cacheKey: "services",
        getUrl: "service",
        getMultipleUrl: "services",
        create: "services/create",
        delete: "service/delete",
    },
    "invoices": {
        cacheKey: "invoices",
        getUrl: "invoice",
        getMultipleUrl: "invoices",
        create: "invoices/create",
        delete: "invoice/delete",
    },
}